/* build 2026-09-01a - republicacao das 9 fotos de cerimonia (fundo azulejo navy) */
/* ==========================================================================
   Floricultura Edelweiss — protótipo estático
   Mesma mecânica do protótipo Reserva Floral: sacola em localStorage,
   sem backend. As regras de marca do deck estão aplicadas em código,
   não só em documento.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var money = function (v) { return BRL.format(v); };

  /* PREÇO SOB CONSULTA (21/08/2026)
     O catálogo real do cliente chegou SEM preço: a planilha do Drive tem as 48
     linhas e NENHUMA célula de preço preenchida (`17-catalogo-do-cliente.md` §1).
     Onde o preço pôde ser casado com o site em produção, a peça tem `preco`;
     onde não pôde, ela tem `sobConsulta: true` e **não ganha número inventado** —
     esta é uma loja real, e preço errado na vitrine é pior que preço ausente.

     Peça sob consulta NÃO entra na sacola: fecha no WhatsApp, pela mesma razão
     da página de assinaturas — o que não tem preço fechado é combinado, não é
     compra. Apagar o `sobConsulta` é o único interruptor a virar quando o preço
     chegar; nada mais no código precisa saber.

     `money(undefined)` devolve "R$ NaN" em silêncio, então todo lugar que
     imprime preço passa por `temPreco` antes. */
  function temPreco(p) { return !p.sobConsulta && typeof p.preco === 'number'; }

  var WHATSAPP = '5561999012375';   // (61) 99901-2375 — confirmado pela loja em 28/08/2026
  var PARCELAS = 3;

  /* PATAMAR DE FRETE GRATIS — 31/08/2026, decisao do Erik.
     Numero unico do site: a barra "Cuidados da casa" da gaveta e o resumo do
     checkout leem os dois daqui. Ele e o mesmo da Reserva Floral, que e a
     referencia do projeto — a loja da Edelweiss nao tinha regra de frete
     nenhuma antes disto, entao mudar o patamar e mexer NESTA linha e em mais
     nenhuma. Abaixo dele o frete continua "a calcular": a loja entrega por
     distancia e nao publicou tabela, e numero de frete inventado na tela que
     fecha a compra e pior que frete ausente (mesma regra do preco sob
     consulta, la em cima). */
  var FRETE_GRATIS = 450;

  /* =======================================================================
     VARIANTES DA SHOPIFY — a ponte entre este catalogo e o checkout real
     (31/08/2026)

     O checkout deixou de ser o WhatsApp e passou a ser o da propria Shopify.
     Para isso a loja precisa de PRODUTO DE VERDADE cadastrado, e o carrinho
     precisa mandar o `variant_id` de cada linha para `/cart/add.js`.

     Este objeto e a UNICA cola entre as duas coisas: chave = o `id` do
     `PRODUTOS` daqui (que e o codigo do catalogo da loja, tipo "1030"),
     valor = o id numerico da variante na Shopify.

     COMO REGERAR (nao editar a mao, sao 49 linhas):
       node scripts/mapa-variantes.js
     Ele le `https://s8cknr-fz.myshopify.com/products.json` — que e publico,
     nao precisa de token — casa pelo SKU e reescreve este bloco inteiro.

     ENQUANTO ESTIVER VAZIO, o botao de pagamento se recusa a seguir e diz
     o porque na tela. Isso e de proposito: mandar o cliente para um checkout
     sem os itens dele e pior do que nao deixar ele ir. Ver `checkout.js`.

     PECA SOB CONSULTA NAO ENTRA AQUI, pela mesma razao de sempre — ela nao
     tem preco e nao entra na sacola. ============================== */
  var VARIANTES = {
    "1030": 46561546240079,
    "1011": 46561546272847,
    "1012": 46561546338383,
    "1009": 46561546371151,
    "1026": 46561546403919,
    "1034": 46561546633295,
    "1029": 46561546666063,
    "1027": 46561546731599,
    "1008": 46561546764367,
    "1031": 46561546797135,
    "1006": 46561546960975,
    "1013": 46561547026511,
    "1040": 46561547059279,
    "2065": 46561547092047,
    "1033": 46561547157583,
    "1028": 46561547419727,
    "1005": 46561547452495,
    "1003": 46561547518031,
    "1025": 46561547550799,
    "1002": 46561547583567,
    "1016": 46561547812943,
    "1038": 46561547845711,
    "1039": 46561547911247,
    "1036": 46561547944015,
    "1037": 46561548009551,
    "2063": 46561548271695,
    "2058": 46561548337231,
    "2046": 46561548369999,
    "2044": 46561548402767,
    "2033": 46561548468303,
    "2048": 46561548894287,
    "200": 46561548959823,
    "2047": 46561549025359,
    "1024": 46561549058127,
    "1021": 46561549090895,
    "1041": 46561549287503,
    "2045": 46561549320271,
    "2064": 46561549353039,
    "2037": 46561549385807,
    "2043": 46561549418575,
    "1020": 46561549647951,
    "2055": 46561549680719,
    "2035": 46561549746255,
    "2031": 46561549811791,
    "2052": 46561549844559,
    "2062": 46561550106703,
    "2053": 46561550139471,
    "1004": 46561550172239,
    "1007": 46561550237775
  };

  function icones() {
    if (window.lucide && typeof window.lucide.createIcons === 'function') {
      window.lucide.createIcons();
    }
  }

  /* =======================================================================
     DADOS
     Preços são ILUSTRATIVOS — nenhum foi fornecido pela Edelweiss.
     ======================================================================= */

  /* As fotos de categoria vêm de peças REAIS do catálogo da loja,
     colhidas do site em produção em 10/08/2026 e refotografadas na banca.
     Brief e rastro dos arquivos-base em 10-brief-fotos-categorias.md.

     São arquivos PRÓPRIOS (cat-*.jpg), não sobrescrita dos antigos: hero-banca
     e companhia continuam servindo aos produtos, e trocar o arquivo por baixo
     mudaria produto junto com categoria.

     A LIÇÃO QUE SOBREVIVEU às três mexidas nesta lista (4 categorias até
     17/08, 3 depois, 4 de novo em 21/08): categoria neste protótipo NÃO é só
     um rótulo. Ela é a rota (`/collections/all?cat=…`), o card da home, a migalha da
     PDP e o `pcard__cat`. Tirar da lista sem tirar os produtos deixa peça
     órfã com categoria em branco e migalha morta; PÔR na lista sem pôr
     produto deixa card dizendo "0 PEÇAS" e link para grade vazia. Os dois
     erros já aconteceram aqui. */
  /* QUATRO CATEGORIAS desde 21/08/2026, e a lista saiu do catálogo REAL do
     cliente (47 peças no Drive `02_Inputs do Cliente`), não do protótipo.
     Ver `17-catalogo-do-cliente.md`.

     Duas decisões que não se adivinham lendo isto:

     · `arranjos` ("Cachepôs & Arranjos") SAIU. No catálogo real não existe
    essa gaveta: os "arranjos" da loja ou são fúnebres — e aí são Coroas de Flores —
       ou são cesta/caixa de presente, e aí são `cestas`. A categoria só existia
       porque o protótipo tinha duas peças inventadas para ela.

     · `plantas` VOLTA, mas fundida com orquídeas e com outro nome. A categoria
       "Plantas & Presentes" foi removida a pedido em 17/08 por ter só duas
       peças; o catálogo real tem 5 orquídeas + 2 plantas, e sete peças
       sustentam uma gaveta. O id continua `plantas` de propósito: é o mesmo
       da rota antiga, então `/collections/all?cat=plantas` volta a responder em vez
       de cair em "Todas as peças".

     ARMADILHA DE LAYOUT: a fileira de categoria da home tem teto de 320px por
     card a partir de 1000px (15-auditoria-imagens §4b). QUATRO cards de 320
     pedem 1280px + vãos, e o miolo da home tem 1160 — a 1240 de viewport a
     fileira quebra 3+1. Tratado no bloco 18 do styles.css. */
  var CATEGORIAS = [
    { id: 'buques',    nome: 'Buquês',              registro: 'presente',  img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cat-buques-humanizada.png?v=135138240929514349141787594457' },
    { id: 'cestas',    nome: 'Cestas & Presentes',  registro: 'presente',  img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cat-cestas.jpg?v=35061589083871014531787593381' },
    { id: 'plantas',   nome: 'Orquídeas & Plantas', registro: 'presente',  img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cat-orquideas.jpg?v=61287393536871699171787593381' },
    { id: 'cerimonia', nome: 'Coroas de Flores',   registro: 'cerimonia', img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-cat-homenagem-azul-marinho.png?v=36205774201203333821787593381' }
  ];

  /* AS DUAS FOTOS NOVAS DE CATEGORIA SÃO PROVISÓRIAS, e a troca já corrigiu um
     erro: `cat-cestas.jpg` e `cat-orquideas.jpg` nasceram das duas fotos que o
     protótipo já tinha, mas TROCADAS entre si — a foto que servia "Cachepôs &
     Arranjos" mostra antúrio em vaso (é planta) e a que servia a categoria
     "Plantas" removida mostra uma cesta de flores (é cesta). Cada uma foi para
     o rótulo que ela de fato ilustra, e o arquivo ganhou o nome do que mostra.
     Os masters antigos continuam em `_categoria-arranjos-anterior/` e
     `_categoria-plantas-removida/`.

     PENDÊNCIA: `cat-cestas.jpg` tem 900x1200 e o padrão da casa é 1200x1500
     (15-auditoria-imagens §1) — num card de 277px numa tela de 3x faltam 60px
     de largura. As duas devem ser substituídas por foto do catálogo do cliente
     assim que as 47 peças estiverem no disco. */

  /* O CATÁLOGO DEIXOU DE SER INVENTADO EM 21/08/2026.
     Até aqui este array tinha 8 peças de protótipo com preço ilustrativo. Ele
     passou a ser GERADO a partir dos 49 SKUs reais da loja — nome, preço, SKU,
     categoria e foto vindos de `catalogo-site-atual/catalogo-edelweiss.csv`,
     que foi colhido de floriculturaedelweiss.com.br. Ver `17-catalogo-do-cliente.md`.

     TRÊS COISAS QUE MUDARAM DE NATUREZA JUNTO:

     · O `id` agora é o SKU REAL da loja (`1008`, `2043`), não `p1`/`c1`. A PDP
       responde em `/pages/produto?id=1008`, e o id passou a valer fora do protótipo.

     · NENHUM produto tem `nota` nem `avaliacoes`. As do protótipo eram
       inventadas, e nota inventada em peça real é prova social falsa — o
       comentário da PDP já apontava isso como pendência. Os cartões
       simplesmente deixam de mostrar estrela.

     · `complemento: true` é a marca da própria loja (`e_complemento` no CSV):
       Ferrero, vinho, pelúcia e vaso são vendidos como acompanhamento. Eles
       continuam no catálogo, e é deles que a fileira "Levar junto?" se serve.

     O array de protótipo ficou em `_produtos-prototipo.js.txt` e no primeiro
     commit do repo, para quem precisar do caminho de volta. */
  /* <<< CATALOGO GERADO — não editar à mão.
     Sai de `scripts/catalogo-do-site.py`, que lê os 49 SKUs reais da loja.
     Rodar de novo depois de mexer no CSV; edição feita aqui é perdida. >>> */
  var PRODUTOS = [
    { id: "1030", nome: "Buquê Solitário de Girassol + Mosquitinho", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1030.jpg?v=139164340607542780241792080750", preco: 95.9, fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1030.jpg?v=178801611011682440131792080750" },

    { id: "1011", nome: "Girassol unitário + Ferrero Rocher 8un", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1011.jpg?v=29266114787524351091792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1011.jpg?v=171676049285961357421792080750", preco: 109, fotoCliente: true, resumo: "Embalado no Kraft" },

    { id: "1012", nome: "Rosa unitária + Ferrero Rocher 8un", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1012.jpg?v=146253300300339940041792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1012.jpg?v=42034488636196748461792080750", preco: 109, fotoCliente: true, resumo: "Embalada no Kraft" },

    { id: "1009", nome: "Buquê com 2 Girassóis + Astromélia no papel  Kraft, TAM M", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1009.jpg?v=149212799006701251051792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1009.jpg?v=167501618422850060441792080750", preco: 115, fotoCliente: true },

    { id: "1026", nome: "Buquê Girassol + Astromélia", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1026.jpg?v=43807360180201945521792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1026.jpg?v=102350241029999865581792080750", preco: 125.9, fotoCliente: true },

    { id: "1034", nome: "Buquê 3 Kit Kat + 3 Rosas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1034.jpg?v=130583641750221248771792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1034.jpg?v=167059214684926753401792080750", preco: 129.9, fotoCliente: true },

    { id: "1029", nome: "Buquê com 2 Girassóis + Astromélia TAM M", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1029.jpg?v=71485534885980528671792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1029.jpg?v=125179098629679114001792080750", preco: 135.9, fotoCliente: true, resumo: "Buquê com 2 Girassóis + Astromélia + folhagens, TAM M" },

    { id: "1027", nome: "Buquê Mix de Flores Variadas - Tam P", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1027.jpg?v=37136139854517009391792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1027.jpg?v=64289875761229240111792080750", preco: 135.9, fotoCliente: true, resumo: "Buquê delicado com 2 tipos de flores + folhagens, como astromélias e outras da…" },

    { id: "1008", nome: "Buquê 06 Rosas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1008.jpg?v=80998043563980323631792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1008.jpg?v=146477433755651710841792080750", preco: 139.9, de: 150.9, selos: ["promo"], fotoCliente: true, resumo: "Embaladas no papel Kraft" },

    { id: "1031", nome: "Mini Buquê no vinho", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1031.jpg?v=128367654258886099861792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1031.jpg?v=27765414956357037861792080750", preco: 139.9, fotoCliente: true, resumo: "Um presente sofisticado e cheio de significado, perfeito para celebrar momentos…" },

    { id: "1006", nome: "Buquê 06 Rosas Vermelhas em papel Celofane", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1006.jpg?v=31575128960679898291792080750", preco: 150, de: 180, selos: ["promo"], fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1006.jpg?v=55316592503374366761792080750", resumo: "Lindo buquê com 12 Rosas vermelhas em papel Celofane" },

    { id: "1013", nome: "Buquê com 7 Girassóis", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1013.jpg?v=25241142001630782631792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1013.jpg?v=75076071839370769151792080750", preco: 180, fotoCliente: true, resumo: "Embalado no papel Kraft + laço rústico" },

    { id: "1040", nome: "Buquê 7 Rosas rosa", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1040.jpg?v=123847339168738937751792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1040.jpg?v=63034717063939326131792080751", preco: 199.9, fotoCliente: true },

    { id: "2065", nome: "Buquê Van Gogh", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2065.jpg?v=114291684116597005181792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2065.jpg?v=79517970170827795111792080750", preco: 200, de: 210, selos: ["promo"], fotoCliente: true, resumo: "Buquê inspirado na arte de Van Gogh com flores do campo e rosas especiais" },

    { id: "1033", nome: "Buquê Heart", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1033.jpg?v=137095113500605407871792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1033.jpg?v=45339078914494380901792080750", preco: 219.9, fotoCliente: true, resumo: "Buquê em formato de coração com 11 Rosas + Eucalipto" },

    { id: "1028", nome: "Buquê 12 Rosas Vermelhas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1028.jpg?v=120572552639274744171792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1028.jpg?v=107571041288845052601792080750", preco: 229, fotoCliente: true },

    { id: "1005", nome: "Buquê com 12 Rosas vermelhas nacionais", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1005.jpg?v=141846590145879399041792080750", preco: 270.9, de: 299.9, selos: ["promo"], fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1005.jpg?v=137877104380179854191792080750", resumo: "Astromélias e folhagem" },

    { id: "1003", nome: "Buquê com 12 Rosas Vermelhas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1003.jpg?v=131210376270513060041792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1003.jpg?v=95833986962297053431792080750", preco: 279.9, fotoCliente: true, resumo: "Nacionais + folhagens, embalado com sujinho + detalhe de tela + laço" },

    { id: "1025", nome: "Buquê 12 Rosas vermelhas + Ferrero Rocher 8un", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1025.jpg?v=157663064706411219791792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1025.jpg?v=5467227643561130041792080750", preco: 284.9, fotoCliente: true, resumo: "Destribuídos harmoniosamente" },

    { id: "1002", nome: "Buquê com Flores mistas + Lírio Branco.", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1002.jpg?v=49755400296215906281792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1002.jpg?v=100975515720876279131792080750", preco: 300, de: 350, selos: ["promo"], fotoCliente: true, resumo: "No papel celofane transparente e laço de cetim" },

    { id: "1016", nome: "Buquê de Flores Variadas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1016.jpg?v=87677422852873254431792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1016.jpg?v=62897714666790941811792080750", preco: 300.9, de: 350.9, selos: ["promo"], fotoCliente: true, resumo: "Buquê com flores mistas + Girassol" },

    { id: "1038", nome: "Buquê Heart Grande - Rosas + Girassóis", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1038.jpg?v=105730475788461872651792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1038.jpg?v=48235518167651686411792080751", preco: 1499, fotoCliente: true },

    { id: "1039", nome: "Buquê Gigante de Girassóis + Rosa Rosa", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1039.jpg?v=144923121956943431061792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1039.jpg?v=28034767370479754791792080751", preco: 1899.9, fotoCliente: true },

    { id: "1036", nome: "Buquê Heart - Rosas + Gypsophila", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1036.jpg?v=161760679601425129211792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1036.jpg?v=51991526179826764651792080750", preco: 1909, fotoCliente: true },

    { id: "1037", nome: "Buquê 90 Rosas Vermelhas + Gypsophila", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1037.jpg?v=730556220874633851792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1037.jpg?v=99408695011771974411792080750", preco: 2300, fotoCliente: true },

    { id: "d-buque-3-rosas-vermelhas", nome: "Buquê de 3 rosas vermelhas", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-buque-3-rosas-vermelhas.jpg?v=133289255457496555691792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-buque-3-rosas-vermelhas.jpg?v=96432498854983009431792090395", sobConsulta: true, fotoCliente: true },

    { id: "d-buque-colorido-sortido", nome: "Buquê colorido sortido", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-buque-colorido-sortido.jpg?v=150665670328180748911792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-buque-colorido-sortido.jpg?v=30388399458122403681792090395", sobConsulta: true, fotoCliente: true },

    { id: "d-buque-lirios-brancos", nome: "Buquê de lírios brancos", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-buque-lirios-brancos.jpg?v=116188807117889174181792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-buque-lirios-brancos.jpg?v=11396244470876825111792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-buque-rosas-brancas-e-astromelias", nome: "Buquê de rosas brancas e astromélias", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-buque-rosas-brancas-e-astromelias.jpg?v=150090583934132286831792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-buque-rosas-brancas-e-astromelias.jpg?v=528640562587898651792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-buque-tulipas-e-lirios", nome: "Buquê de lírios e rosas em tom pastel", cat: "buques", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-buque-tulipas-e-lirios.jpg?v=17923203793432500541792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-buque-tulipas-e-lirios.jpg?v=94551906252554521031792090394", sobConsulta: true, fotoCliente: true },

    { id: "2063", nome: "Ferrero Rocher T4", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2063.jpg?v=41937891710820572311792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2063.jpg?v=33453698398773256691792080750", preco: 35, complemento: true, fotoCliente: true, resumo: "Caixa com 4 unidades" },

    { id: "2058", nome: "Caixa de Margaridas", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2058.jpg?v=149578311043135987641792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2058.jpg?v=163626559153784767551792080750", preco: 50, fotoCliente: true },

    { id: "2046", nome: "Ferrero Rocher com 8 un", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2046.jpg?v=35250389569291494931792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2046.jpg?v=79014960337333789441792080750", preco: 55, complemento: true, fotoCliente: true },

    { id: "2044", nome: "Pelúcia M", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2044.jpg?v=105754530747997380231792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2044.jpg?v=20378078808299220171792080750", preco: 60, complemento: true, fotoCliente: true },

    { id: "2033", nome: "Vaso aquário de vidro Medio", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2033.jpg?v=45979170264144284091792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2033.jpg?v=176030005607361658701792080750", preco: 60, complemento: true, fotoCliente: true },

    { id: "2048", nome: "Vinho seco Reservado 750ml.", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2048.jpg?v=134255602984436720201792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2048.jpg?v=61060811303765629051792080750", preco: 60, complemento: true, fotoCliente: true },

    { id: "200", nome: "Vinho tinto Olaria suave 750 ml", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-200.jpg?v=3598469927925009151792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-200.jpg?v=65770488367102673451792080751", preco: 65, complemento: true, fotoCliente: true, resumo: "Vinho tinto suave 750 ml" },

    { id: "2047", nome: "Ferrero Rocher com 12", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2047.jpg?v=164128078459699007441792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2047.jpg?v=153109224132395803421792080750", preco: 70, complemento: true, fotoCliente: true, resumo: "Un" },

    { id: "1024", nome: "Vaso de campânula", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1024.jpg?v=54991874328577683251792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1024.jpg?v=122744131017466341121792080750", preco: 100, fotoCliente: true, resumo: "Só temos na cor rosa" },

    { id: "1021", nome: "Arranjo com mini Rosas no cachepô de papel.", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1021.jpg?v=171143297035230045081792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1021.jpg?v=181088027708248313221792080750", preco: 125.9, fotoCliente: true, resumo: "+ Laço + sujinho colorido" },

    { id: "1041", nome: "Coração de Rosas com Ferrero Rocher", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1041.jpg?v=70515596612828971581792080750", preco: 140, fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1041.jpg?v=35432707283823181001792080750", resumo: "Um presente apaixonante para tornar qualquer momento inesquecível" },

    { id: "2045", nome: "Arranjo flores nobres com 3 unidades kit kat e vinho", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2045.jpg?v=88928175810908840301792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2045.jpg?v=37220781958358626631792080750", preco: 170, fotoCliente: true },

    { id: "2064", nome: "Kit de Presente com Girassóis, Astromélias e Ferrero Rocher 8un", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2064.jpg?v=143573270714369904221792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2064.jpg?v=78650616701394434051792080750", preco: 189.9, fotoCliente: true },

    { id: "2037", nome: "Cesta de Flores do Campo + Chocolate", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2037.jpg?v=170355669262872466461792080750", preco: 190.9, de: 200, selos: ["promo"], fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2037.jpg?v=165754770143174327301792080750", resumo: "Cesta de flores do campo + Ferrero Rocher 8un" },

    { id: "2043", nome: "Arranjo com 2 rosas colombianas + vinho tinto", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2043.jpg?v=63361268355927307751792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2043.jpg?v=9888911180942934271792080750", preco: 199.9, de: 205.9, selos: ["promo"], fotoCliente: true, resumo: "Arranjo na caixa cartão com 2 rosas colombianas + vinho" },

    { id: "d-mao-d-cesta-girassol-e-rosas-branc", nome: "Caixa de girassol com rosas brancas", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-mao-d-cesta-girassol-e-rosas-branc.jpg?v=21268250391932894641792090394", sobConsulta: true, fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-mao-d-cesta-girassol-e-rosas-branc.jpg?v=96582159043281732441792090394" },

    { id: "d-cesta-girassois-laco-dourado", nome: "Cesta de girassóis com laço dourado", cat: "cestas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-cesta-girassois-laco-dourado.jpg?v=31524519837998906551792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-cesta-girassois-laco-dourado.jpg?v=157190322047761590451792090395", sobConsulta: true, fotoCliente: true },

    { id: "1020", nome: "Mini orquídea em cachepô trançado", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1020.jpg?v=84285966188707972521792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1020.jpg?v=26305275948351257271792080750", preco: 130, fotoCliente: true },

    { id: "2055", nome: "Orquídea simbidium no arranjo rústico", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2055.jpg?v=38828889531870373821792080750", preco: 150, de: 180, selos: ["promo"], fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2055.jpg?v=51175773207670806391792080750" },

    { id: "2035", nome: "Orquídea Branca", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2035.jpg?v=13652882189923366831792080750", preco: 200, fotoCliente: true, fotoMao: true, img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2035.jpg?v=73512704510680717771792080750", resumo: "Embalada para presente" },

    { id: "2031", nome: "orquidea com pelucia", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2031.jpg?v=176668776000768827531792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2031.jpg?v=144031357862492721541792080750", preco: 280, fotoCliente: true, resumo: "Orquidea branca embalada para presente" },

    { id: "d-orquidea-phalaenopsis-amarela-mini", nome: "Orquídea amarela dupla em cachepô de madeira", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-orquidea-phalaenopsis-amarela-mini.jpg?v=103996635330212950831792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-orquidea-phalaenopsis-amarela-mini.jpg?v=172632718209912630771792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-orquidea-phalaenopsis-rosa-mesclad", nome: "Orquídea rosa mesclada com laço dourado", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-orquidea-phalaenopsis-rosa-mesclad.jpg?v=171077002347121308631792090395", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-orquidea-phalaenopsis-rosa-mesclad.jpg?v=22700467413941724351792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-planta-anturio-vermelho", nome: "Antúrio vermelho", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-planta-anturio-vermelho.jpg?v=53580368211435850491792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-planta-anturio-vermelho.jpg?v=158336784741167092051792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-orquidea-phalaenopsis-pink-mini-em", nome: "Orquídea pink mini em cachepô rústico", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-orquidea-phalaenopsis-pink-mini-em.jpg?v=46218781161738722471792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-orquidea-phalaenopsis-pink-mini-em.jpg?v=85338732960419710131792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-planta-copo-de-leite-vinho", nome: "Copo-de-leite vinho", cat: "plantas", registro: "presente",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-planta-copo-de-leite-vinho.jpg?v=80453507160413368231792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-planta-copo-de-leite-vinho.jpg?v=116518775007950118021792090394", sobConsulta: true, fotoCliente: true },

    { id: "2052", nome: "Coroa de Flores do campo", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2052.jpg?v=71749309905524470151792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2052.jpg?v=46250229838547594841792080750", preco: 259.9, fotoCliente: true, resumo: "Faixa de homenagem grátis: escreva o nome do homenageado e uma frase" },

    { id: "2062", nome: "Coroa de Flores, Circulo de rosas brancas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2062.jpg?v=70647589696871630791792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2062.jpg?v=89331586411704108531792080750", preco: 450, fotoCliente: true, resumo: "Faixa de homenagem grátis: escreva o nome do homenageado e uma frase" },

    { id: "2053", nome: "Coroa de Flores, Rosas com flores do campo e lírios", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-2053.jpg?v=113952455536005807181792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-2053.jpg?v=143487331237644019241792080750", preco: 450, fotoCliente: true, resumo: "Faixa de homenagem grátis: escreva o nome do homenageado e uma frase" },

    { id: "1004", nome: "Coroa de Flores de rosa branca e pêssego com lírio branco", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1004.jpg?v=53646468763906961071792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1004.jpg?v=166140559445728328431792080750", preco: 599.9, fotoCliente: true, resumo: "Faixa de homenagem grátis: escreva o nome do homenageado e uma frase" },

    { id: "1007", nome: "Coroa de Flores, Coração", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__aprovada3-1007.jpg?v=110204223492834374211792080750", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__zoom3-1007.jpg?v=144105138322484323221792080750", preco: 950, fotoCliente: true, resumo: "Faixa de homenagem grátis: escreva o nome do homenageado e uma frase" },

    { id: "d-arranjo-flores-brancas", nome: "Arranjo de flores brancas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-arranjo-flores-brancas.jpg?v=172024935922502092061792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-arranjo-flores-brancas.jpg?v=129271200251275323881792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-arranjo-flores-brancas-e-vermelhas", nome: "Arranjo de flores brancas e vermelhas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-arranjo-flores-brancas-e-vermelhas.jpg?v=151778505016615013061792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-arranjo-flores-brancas-e-vermelhas.jpg?v=136894935723945920941792090395", sobConsulta: true, fotoCliente: true },

    { id: "d-arranjo-lirios-e-rosas-brancas", nome: "Arranjo de lírios e rosas brancas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-arranjo-lirios-e-rosas-brancas.jpg?v=37958451064230692251792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-arranjo-lirios-e-rosas-brancas.jpg?v=12359515264097662811792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-coroa-de-flores-com-flores-do-camp", nome: "Coroa de flores do campo com rosas e lírios", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-coroa-de-flores-com-flores-do-camp.jpg?v=117781572236914544381792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-coroa-de-flores-com-flores-do-camp.jpg?v=3019528156447656791792090395", sobConsulta: true, fotoCliente: true },

    { id: "d-coroa-flores-brancas-com-lirios", nome: "Coroa de flores brancas com lírios", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-coroa-flores-brancas-com-lirios.jpg?v=179812324035282744271792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-coroa-flores-brancas-com-lirios.jpg?v=59854585921997325861792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-coroa-flores-brancas-e-amarelas", nome: "Coroa de flores brancas e amarelas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-coroa-flores-brancas-e-amarelas.jpg?v=28168480740464281141792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-coroa-flores-brancas-e-amarelas.jpg?v=142961461049907975661792090394", sobConsulta: true, fotoCliente: true },

    { id: "d-coroa-rosas-vermelhas", nome: "Coroa de rosas vermelhas", cat: "cerimonia", registro: "cerimonia",
      img: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-d-coroa-rosas-vermelhas.jpg?v=157041027289812817861792090394", img2: "//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-prod__sc-zoom-d-coroa-rosas-vermelhas.jpg?v=155490732325283421431792090394", sobConsulta: true, fotoCliente: true }
  ];
  /* <<< FIM DO CATALOGO GERADO >>> */

  /* O ADMIN DA SHOPIFY MANDA NO CATALOGO (23/10 preco; 26/10 tudo)
     O checkout e o da Shopify (VARIANTES -> /cart/add.js), entao a vitrine tem de
     mostrar o que o admin diz: o cliente via R$ 1.499 e pagava R$ 400, e a dona
     renomeava uma coroa no admin e o site seguia com o nome antigo.
     `window.EDW_PRECOS` nasce no `theme.liquid`, um item por produto PUBLICADO.
     Daqui em diante, como numa loja Shopify comum:
       - nome, fotos, preco, "de", sob consulta e variante vem do admin;
       - produto novo no admin entra na vitrine sozinho (categoria pela tag);
       - produto em rascunho/arquivado SAI da vitrine.
     A lista acima so contribui com o que o admin nao tem: selos, resumo,
     fotoCliente/fotoMao (ordem da grade) e complemento.
     Tag `sob-consulta` ou preco 0 no admin vira "Sob consulta".
     Se o mapa vier vazio (Liquid quebrado), fica a lista acima inteira: vitrine
     velha e melhor que vitrine vazia. */
  (function () {
    var m = window.EDW_PRECOS || {};
    var chaves = Object.keys(m).filter(function (k) { return m[k]; });
    if (!chaves.length) return;
    var porId = {};
    PRODUTOS.forEach(function (p) { porId[p.id] = p; });
    var novo = [];
    PRODUTOS.forEach(function (p) {
      if (m[p.id]) novo.push(p);
    });
    chaves.forEach(function (k) {
      if (porId[k]) return;
      var s = m[k];
      var cat = s.cat || 'cestas';
      novo.push({ id: k, nome: s.n, cat: cat, registro: cat === 'cerimonia' ? 'cerimonia' : 'presente',
                  complemento: !!s.comp, fotoCliente: true });
    });
    novo.forEach(function (p) {
      var s = m[p.id];
      p.nome = s.n;
      if (s.img) p.img = s.img;
      if (s.img2) p.img2 = s.img2;
      if (s.v) VARIANTES[p.id] = s.v;
      if (s.sc) { p.sobConsulta = true; delete p.preco; delete p.de; return; }
      p.sobConsulta = false;
      p.preco = s.p;
      if (s.de > s.p) { p.de = s.de; }
      else {
        delete p.de;
        if (p.selos) p.selos = p.selos.filter(function (x) { return x !== 'promo'; });
      }
    });
    PRODUTOS.length = 0;
    Array.prototype.push.apply(PRODUTOS, novo);
  })();

  /* WHATSAPP entra no objeto exportado desde 14/08/2026 por causa da página de
     assinaturas, que fecha por lá. É o número, e não um segundo lugar onde ele
     é escrito: quando o real substituir o de exemplo, a troca continua sendo
     numa linha só, aqui em cima. */
  window.EDELWEISS = { CATEGORIAS: CATEGORIAS, PRODUTOS: PRODUTOS, money: money,
                       PARCELAS: PARCELAS, WHATSAPP: WHATSAPP, temPreco: temPreco,
                       FRETE_GRATIS: FRETE_GRATIS, ler: ler,
                       VARIANTES: VARIANTES, achar: achar };

  /* =======================================================================
     SACOLA
     ======================================================================= */

  var CHAVE = 'edelweiss.sacola';

  /* O localStorage pode ser bloqueado quando a pagina e aberta direto do
     disco (file://) ou com cookies desligados. Nesse caso a sacola vive
     so na memoria da aba: o site continua funcionando, so nao lembra
     entre visitas. Melhor que quebrar. */
  var memoria = [];
  var temStorage = (function () {
    try { localStorage.setItem('__t', '1'); localStorage.removeItem('__t'); return true; }
    catch (e) { return false; }
  })();

  function ler() {
    if (!temStorage) return memoria;
    try { return JSON.parse(localStorage.getItem(CHAVE)) || []; }
    catch (e) { return []; }
  }
  function gravar(s) {
    if (temStorage) {
      try { localStorage.setItem(CHAVE, JSON.stringify(s)); }
      catch (e) { memoria = s; }
    } else {
      memoria = s;
    }
    pintarSacola();
  }
  function achar(id) {
    for (var i = 0; i < PRODUTOS.length; i++) { if (PRODUTOS[i].id === id) return PRODUTOS[i]; }
    return null;
  }

  /* `qtd` e `silencio` entraram em 17/08/2026 com a PDP nova.
     qtd: a PDP passou a ter contador antes do botão, então "adicionar" deixou
     de ser sempre uma unidade. Continua opcional — quem chama sem ele soma 1,
     como antes.
     silencio: a PDP adiciona a peça E os acompanhamentos marcados na MESMA
     ação. Sem isso a gaveta abriria uma vez por item e o `pintarSacola` de
     cada chamada seria descartado pelo seguinte. Quem adiciona em lote passa
     silencio=true nos primeiros e false no último. */
  window.EDELWEISS.adicionar = function (id, props, qtd, silencio) {
    var s = ler();
    var n = Math.max(1, parseInt(qtd, 10) || 1);
    var existente = null;
    for (var i = 0; i < s.length; i++) { if (s[i].id === id && !props) existente = s[i]; }
    if (existente) { existente.qtd += n; }
    else { s.push({ id: id, qtd: n, props: props || null }); }
    gravar(s);
    if (!silencio) abrirCarrinho();
  };

  function mudarQtd(indice, delta) {
    var s = ler();
    if (!s[indice]) return;
    s[indice].qtd += delta;
    if (s[indice].qtd < 1) s.splice(indice, 1);
    gravar(s);
  }

  /* A lixeira entrou em 31/08/2026 com a gaveta nova. Ela NAO e o mesmo que
     apertar "menos" ate zerar: com tres unidades na linha, o caminho antigo
     pedia tres cliques e passava por dois estados intermediarios que ninguem
     queria ver. */
  function remover(indice) {
    var s = ler();
    if (!s[indice]) return;
    s.splice(indice, 1);
    gravar(s);
  }

  /* A BARRA "CUIDADOS DA CASA".
     Fica FORA de [data-carrinho-rodape] de proposito — o rodape some quando o
     carrinho esvazia e a barra continua, que e o primeiro dos dois prints.
     Por isso ela e pintada ANTES do `return` do estado vazio, e nao junto dos
     totais. */
  function pintarFrete(total) {
    /* $$ e nao $: a pagina de checkout tem DUAS barras — a do resumo do pedido,
       dentro do <main>, e a da gaveta, no fim do <body>. Com querySelector so a
       primeira do DOM era pintada e a outra ficava travada no estado vazio.
       Vale para os totais logo abaixo pelo mesmo motivo. */
    $$('[data-frete]').forEach(function (barra) { pintarUmaBarra(barra, total); });

    /* A linha "Frete" existe so no resumo do checkout. Abaixo do patamar ela
       diz "A calcular" e nao um numero: a loja entrega por distancia e nao
       publicou tabela. */
    $$('[data-frete-valor]').forEach(function (el) {
      el.textContent = total >= FRETE_GRATIS ? 'Gr\u00e1tis' : 'A calcular';
    });
  }

  function pintarUmaBarra(barra, total) {
    var falta  = Math.max(0, FRETE_GRATIS - total);
    var titulo = $('[data-frete-titulo]', barra);
    var nota   = $('[data-frete-nota]', barra);
    var enche  = $('[data-frete-preenche]', barra);
    var meta   = $('[data-frete-meta]', barra);

    /* Sem centavos: o patamar e um numero redondo e ", 00" no rotulo do
       trilho so acrescenta ruido ao lado de uma barra de 6px. */
    if (meta) meta.textContent = 'R$ ' + FRETE_GRATIS;
    if (enche) enche.style.width = Math.min(100, (total / FRETE_GRATIS) * 100) + '%';

    if (falta > 0) {
      barra.removeAttribute('data-completo');
      if (titulo) titulo.innerHTML = 'Faltam <b>' + money(falta) + '</b> para frete grátis';
      if (nota) nota.textContent = 'Acrescente flores e a entrega fica por nossa conta.';
    } else {
      barra.setAttribute('data-completo', '');
      if (titulo) titulo.innerHTML = 'Frete grátis <b>liberado</b> neste pedido';
      /* A NOTA NAO PODE FALAR EM "proxima tela". A mesma barra e desenhada em
         DOIS lugares — a gaveta, onde a proxima tela existe, e o resumo do
         checkout, onde ela ja e a tela atual. Frase verdadeira so num dos dois
         vira mentira no outro, e o defeito nao aparece testando pela gaveta.
         Vale para qualquer copy que este arquivo escreva daqui em diante. */
      if (nota) nota.textContent = 'A entrega sai por nossa conta neste pedido.';
    }
  }

  function pintarSacola() {
    var s = ler();
    var linhas = $('[data-carrinho-linhas]');
    var vazio  = $('[data-carrinho-vazio]');
    var rodape = $('[data-carrinho-rodape]');
    var total = 0, itens = 0;

    s.forEach(function (l) {
      var p = achar(l.id);
      if (p) { total += p.preco * l.qtd; itens += l.qtd; }
    });

    var cabecalho = $('[data-contador-header]');
    if (cabecalho) cabecalho.textContent = itens;
    var fab = $('[data-contador-fab]');
    if (fab) {
      fab.textContent = itens;
      if (itens > 0) { fab.setAttribute('data-tem', ''); } else { fab.removeAttribute('data-tem'); }
    }

    pintarFrete(total);

    if (!linhas) return;

    if (!s.length) {
      linhas.innerHTML = '';
      if (vazio)  vazio.classList.remove('is-hidden');
      if (rodape) rodape.style.display = 'none';
      $$('[data-subtotal]').forEach(function (el) { el.textContent = money(0); });
      $$('[data-total]').forEach(function (el) { el.textContent = money(0); });
      icones();
      return;
    }
    if (vazio)  vazio.classList.add('is-hidden');
    if (rodape) rodape.style.display = '';

    linhas.innerHTML = s.map(function (l, i) {
      var p = achar(l.id);
      if (!p) return '';
      var props = '';
      if (l.props) {
        props = Object.keys(l.props).filter(function (k) { return l.props[k]; })
          .map(function (k) { return '<p class="linha-item__prop">' + k + ': ' + l.props[k] + '</p>'; })
          .join('');
      }
      return '<div class="linha-item">' +
        '<img src="' + p.img + '" alt="">' +
        '<div><p class="linha-item__n">' + p.nome + '</p>' + props +
          '<span class="linha-item__qtd">' +
            '<button data-menos="' + i + '" aria-label="Menos um">&minus;</button>' +
            '<span>' + l.qtd + '</span>' +
            '<button data-mais="' + i + '" aria-label="Mais um">+</button>' +
          '</span>' +
        '</div>' +
        '<span class="linha-item__lado">' +
          '<button class="linha-item__rm" data-remover="' + i + '" aria-label="Remover ' + p.nome + '">' +
            '<i data-lucide="trash-2"></i></button>' +
          '<span class="linha-item__p">' + money(p.preco * l.qtd) + '</span>' +
        '</span>' +
      '</div>';
    }).join('');

    $$('[data-subtotal]').forEach(function (el) { el.textContent = money(total); });
    $$('[data-total]').forEach(function (el) { el.textContent = money(total); });

    $$('[data-menos]', linhas).forEach(function (b) {
      b.addEventListener('click', function () { mudarQtd(+b.getAttribute('data-menos'), -1); });
    });
    $$('[data-mais]', linhas).forEach(function (b) {
      b.addEventListener('click', function () { mudarQtd(+b.getAttribute('data-mais'), +1); });
    });
    $$('[data-remover]', linhas).forEach(function (b) {
      b.addEventListener('click', function () { remover(+b.getAttribute('data-remover')); });
    });
    icones();
  }

  /* =======================================================================
     GAVETAS
     ======================================================================= */

  function abrirCarrinho() {
    var g = $('[data-carrinho]'); var o = $('[data-overlay-carrinho]');
    if (g) g.setAttribute('data-aberto', '');
    if (o) o.setAttribute('data-aberto', '');
    document.body.style.overflow = 'hidden';
  }
  function fecharCarrinho() {
    var g = $('[data-carrinho]'); var o = $('[data-overlay-carrinho]');
    if (g) g.removeAttribute('data-aberto');
    if (o) o.removeAttribute('data-aberto');
    document.body.style.overflow = '';
  }
  function abrirMenu() {
    var g = $('[data-menu]'); var o = $('[data-overlay-menu]');
    if (g) g.setAttribute('data-aberto', '');
    if (o) o.setAttribute('data-aberto', '');
  }
  function fecharMenu() {
    var g = $('[data-menu]'); var o = $('[data-overlay-menu]');
    if (g) g.removeAttribute('data-aberto');
    if (o) o.removeAttribute('data-aberto');
  }

  /* =======================================================================
     RENDERIZAÇÃO
     ======================================================================= */

  function cardProduto(p) {
  /* Card só existe no registro PRESENTE. Coroas de Flores usa lista. */
    var selos = (p.selos || []).map(function (s) {
      if (s === 'promo') {
        var pct = p.de ? Math.round((1 - p.preco / p.de) * 100) : 0;
        return '<span class="badge badge--promo">-' + pct + '%</span>';
      }
      if (s === 'novo') return '<span class="badge badge--novo">Novo</span>';
      if (s === 'top')  return '<span class="badge badge--top">Mais pedido</span>';
      return '';
    }).join('');

    var cat = CATEGORIAS.filter(function (c) { return c.id === p.cat; })[0];

    /* SEGUNDA FOTO (`img2`): o zoom nas flores, que entra no hover.
       A segunda <img> é DECORATIVA — alt vazio e aria-hidden. Ela mostra o
       mesmo produto que a primeira já nomeou; anunciá-la de novo faria o
       leitor de tela ler o nome duas vezes por card. Quem não tem hover
       (celular) nem carrega o arquivo: o CSS a esconde com display:none e
       o `loading="lazy"` impede o download. */
    var zoom = p.img2
      ? '<img class="pcard__zoom" src="' + p.img2 + '" alt="" aria-hidden="true" loading="lazy">'
      : '';

    return '<article class="pcard">' +
      '<a class="pcard__fig' + (p.img2 ? ' pcard__fig--dupla' : '') +
         '" href="' + edwHref(p.id) + '">' +
        '<img src="' + p.img + '" alt="' + p.nome + '" loading="lazy">' +
        zoom +
        (selos ? '<span class="pcard__badges">' + selos + '</span>' : '') +
      '</a>' +
      '<span class="pcard__cat">' + (cat ? cat.nome : '') + '</span>' +
      '<h3 class="pcard__n"><a href="' + edwHref(p.id) + '">' + p.nome + '</a></h3>' +
      (p.nota ? '<span class="pcard__nota"><i data-lucide="star"></i>' + p.nota +
                ' <span>(' + p.avaliacoes + ')</span></span>' : '') +
      '<span class="pcard__precos">' +
        (temPreco(p)
          ? (p.de ? '<span class="pcard__de">' + money(p.de) + '</span>' : '') +
            '<span class="pcard__por">' + money(p.preco) + '</span>'
          : '<span class="pcard__por pcard__por--consulta">Sob consulta</span>') +
      '</span>' +
      '<p class="pcard__parc">' +
        (temPreco(p) ? PARCELAS + 'x de ' + money(p.preco / PARCELAS) + ' sem juros'
                     : 'Fechamos pelo WhatsApp') +
      '</p>' +
    '</article>';
  }

  function itemLista(p) {
    /* Registro CERIMÔNIA: sem card, sem selo, sem nota, sem parcelamento
       em destaque. O deck manda uma tinta e silêncio.

       O item é uma COLUNA, não uma linha: foto, nome, descrição, preço, um
       embaixo do outro. Tudo é <span> porque o item inteiro é um <a>, e <p>
       dentro de <a> é conteúdo de bloco dentro de inline: HTML inválido.
       O mesmo markup sai do pagina.js, na PLP — um componente, dois lugares. */
    return '<a class="lista__i" href="' + edwHref(p.id) + '">' +
      /* SEGUNDA FOTO na pele Cerimonia. Mesma tecnica do card (empilhar e
         revelar por opacidade), mas SEM o scale do .pcard: o deck proibe
         movimento aqui. So a troca, em silencio. */
      '<span class="lista__fig' + (p.img2 ? ' lista__fig--dupla' : '') + '">' +
        '<img src="' + p.img + '" alt="' + p.nome + '" loading="lazy">' +
        (p.img2 ? '<img class="lista__zoom" src="' + p.img2 +
                  '" alt="" aria-hidden="true" loading="lazy">' : '') +
      '</span>' +
      '<span class="lista__n">' + p.nome + '</span>' +
      '<span class="lista__d">' + (p.resumo || '') + '</span>' +
      '<span class="lista__p">' + (temPreco(p) ? money(p.preco) : 'Sob consulta') + '</span>' +
    '</a>';
  }

  function pintarHome() {
    var cats = $('[data-categorias]');
    if (cats) {
      cats.innerHTML = CATEGORIAS.map(function (c) {
        var n = PRODUTOS.filter(function (p) { return p.cat === c.id; }).length;
        return '<a class="cat' + (c.registro === 'cerimonia' ? ' cat--cerimonia' : '') +
                 '" href="' + edwCol(c.id) + '">' +
          '<img src="' + c.img + '" alt="' + c.nome + '" loading="lazy">' +
          '<span class="cat__cap"><span class="cat__n">' + c.nome + '</span>' +
          '<span class="cat__q">' + n + (n === 1 ? ' peça' : ' peças') + '</span></span>' +
        '</a>';
      }).join('');
    }

    /* A HOME TEM TETO DESDE 21/08/2026, e ele não é enfeite.
       Até aqui `pintarHome` despejava TODOS os produtos do registro presente e
       TODOS os de cerimônia, sem corte. Com as 8 peças inventadas do protótipo
       isso passava despercebido; com o catálogo real do cliente são ~34 peças
       de presente e ~13 de cerimônia, e a home viraria uma parede de catálogo
       entre o hero e o editorial — a página deixaria de ser uma porta e viraria
       a PLP com outro nome.

       OITO e TRÊS não são números redondos escolhidos no olho: oito é duas
       fileiras CHEIAS na grade de quatro colunas do `.product-grid`, e três é
       uma fileira cheia da `.lista`, que tem exatamente 3 colunas de 1000px
       para cima (15-auditoria-imagens §4c). Fileira pela metade é o que faz
       grade parecer sobra.

       O link "ver todas" mora no HTML e some quando NÃO houve corte: com
       catálogo pequeno ele prometeria uma página que não tem mais nada. */
    /* QUAIS oito, e não só quantos. Com o catálogo real o array vem ordenado
       por categoria e, dentro dela, do mais barato ao mais caro — então um
       `slice(0,8)` cru devolvia os OITO BUQUÊS MAIS BARATOS, todos da mesma
       gaveta e todos na mesma faixa de preço. Numa seção chamada "Na banca
       esta semana" isso lê como catálogo truncado, não como amostra.

       A regra é rodízio entre categorias: pega uma peça de cada gaveta por
       vez, começando pelas que estão em promoção. Assim as quatro categorias
       aparecem na primeira fileira e a segunda repete o ciclo.

       COMPLEMENTO FICA DE FORA. Ferrero, vinho, pelúcia e vaso são a marca
       `e_complemento` da própria loja: são o que se leva JUNTO, e a fileira
       "Levar junto?" da PDP já é a casa deles. Na vitrine da home eles
       roubariam lugar de peça de flor — e são justamente os mais baratos, que
       é como eles chegariam aqui. */
    var dest = $('[data-destaques]');
    if (dest) {
      var presentes = PRODUTOS.filter(function (p) {
        return p.registro === 'presente' && !p.complemento;
      });
      /* Dentro de cada gaveta, quem tem FOTO DO CLIENTE passa na frente.
         O catálogo tem duas fotografias convivendo: as 44 peças fotografadas
         pela loja (parede bege, peça sobre pedra) e 23 packshots de fundo
         branco herdados do site antigo, que são o que o §6 dos tokens proíbe.
         Elas não podem sumir — a loja vende essas peças —, mas a home é a
         vitrine, e vitrine mistura de duas fotografias lê como site remendado.
         Peça em promoção continua na frente entre iguais. */
      /* A VITRINE É A FOTO NA MÃO (21/08/2026, pedido do Erik).
         As oito peças da home foram refotografadas com a florista segurando a
         peça, produto centralizado, loja desfocada atrás — `fotoMao`. Elas
         passam na frente de tudo aqui, senão o rodízio sorteia peça de pedestal
         e a vitrine vira duas fotografias misturadas. Na PLP e na PDP o
         pedestal continua: lá o assunto é a peça, não quem a entrega. */
      var fila = {}, ordemCat = [];
      presentes.slice().sort(function (a, b) {
        var ma = a.fotoMao ? 0 : 1, mb = b.fotoMao ? 0 : 1;
        if (ma !== mb) return ma - mb;
        var fa = a.fotoCliente ? 0 : 1, fb = b.fotoCliente ? 0 : 1;
        if (fa !== fb) return fa - fb;
        var pa = (a.selos || []).indexOf('promo') !== -1 ? 0 : 1;
        var pb = (b.selos || []).indexOf('promo') !== -1 ? 0 : 1;
        return pa - pb;
      }).forEach(function (p) {
        if (!fila[p.cat]) { fila[p.cat] = []; ordemCat.push(p.cat); }
        fila[p.cat].push(p);
      });
      var escolhidos = [], volta = 0;
      while (escolhidos.length < 8 && volta < 40) {
        var achou = false;
        for (var k = 0; k < ordemCat.length && escolhidos.length < 8; k++) {
          var f = fila[ordemCat[k]];
          if (f.length) { escolhidos.push(f.shift()); achou = true; }
        }
        if (!achou) break;
        volta++;
      }
      dest.innerHTML = escolhidos.map(cardProduto).join('');
      var maisP = $('[data-ver-mais="presente"]');
      if (maisP && presentes.length <= escolhidos.length) maisP.hidden = true;
    }

    var cer = $('[data-cerimonia]');
    if (cer) {
      var cerimonias = PRODUTOS.filter(function (p) { return p.registro === 'cerimonia'; });
      cer.innerHTML = cerimonias.slice(0, 3).map(itemLista).join('');
      var maisC = $('[data-ver-mais="cerimonia"]');
      if (maisC && cerimonias.length <= 3) maisC.hidden = true;
    }
    icones();
  }

  /* =======================================================================
     AVALIAÇÕES DE CLIENTES
     Transcritas do Google em 10/08/2026, palavra por palavra (CID
     3292062322138215205). São 11 no total, todas 5 estrelas; as 9 com texto
     estão aqui. NÃO EDITE OS TEXTOS — para mostrar menos, apague o objeto.

     ⚠ Pesquisar "floricultura edelweiss avaliações" devolve elogios de OUTRA
     empresa, a Edelweiss Flores e Presentes de João Pessoa/PB. O Instagram
     desta loja é @floriculturaedelweiss; @edelweissfloricultura é a de lá.

     As datas vêm das datas relativas do Google e são aproximadas.
     Contexto completo em AVALIACOES-pesquisa.md.
     ======================================================================= */
  /* TRÊS no ar. Eram nove, e nove ninguém lê — as últimas ficavam abaixo da
     dobra sem nunca serem vistas, e as antigas diluíam as recentes.

     O critério não foi "as mais elogiosas": todas são 5 estrelas, então elogio
     não desempata. Foi COBRIR TRÊS PROVAS DIFERENTES, sem repetir o mesmo
     argumento:
       · Milena Lins  → o processo. WhatsApp com foto do buquê antes de sair
         para entrega. É exatamente o que o site promete; ela prova que já é
         prática da casa, não funcionalidade inventada no e-commerce.
       · Andre Mâgrisso → a urgência. Atendido às 19:00 com "as últimas rosas
         disponíveis na cidade". Floricultura se vende em cima da hora, e este
         é o único depoimento que documenta isso.
       · Adriana Moura → a pessoa e o produto. Nomeia Dona Esther, que aparece
         em três das avaliações e é o maior ativo humano da loja, e fala da
         qualidade dos arranjos e das plantas.

     Ficaram de fora Rafael Lima e Caio Peres — os dois dizem "atendimento
     excelente" e nada mais, logo são redundantes entre si e com os três acima.
     Adriana é de 2021 e as outras duas são de 2026: a troca é consciente, ela
     entra pelo que só ela traz.

     NÃO EDITE OS TEXTOS. Para trocar quem aparece, mova o objeto entre este
     array e o AVALIACOES_ARQUIVO abaixo — nada de reescrever. */
  var AVALIACOES = [
    { autor: 'Milena Lins', nota: 5, fonte: 'Google', contexto: 'junho de 2026',
      texto: 'Serviço excelente! Fiz toda a gestão por WhatsApp e me mandaram fotos do bouquet antes da entrega e no momento. Isso nos dá segurança e demonstra a excelente qualidade de atenção ao cliente.' },

    { autor: 'Andre Mâgrisso', nota: 5, fonte: 'Google', contexto: 'julho de 2026',
      texto: 'Ótimo atendimento. Tudo funcionou perfeitamente, mesmo sendo 19:00hs do dia 12/06, últimas rosas disponíveis na cidade' },

    { autor: 'Adriana Moura', nota: 5, fonte: 'Google', contexto: '2021',
      texto: 'Dona Esther é incrível, tem um ótimo atendimento e além do mais os arranjos e plantas que essa loja vende são de ótima qualidade! Recomendo' }
  ];

  /* ARQUIVO — transcritas do Google no mesmo dia, fora do ar por edição e não
     por qualidade. Ficam aqui porque a transcrição custou pesquisa dirigida por
     navegador (ver §5 do AVALIACOES-pesquisa.md) e apagá-las jogaria fora
     material que não se recupera com uma busca simples. Não são renderizadas. */
  var AVALIACOES_ARQUIVO = [
    { autor: 'Rafael Lima', nota: 5, fonte: 'Google', contexto: 'maio de 2026',
      texto: 'Gostaria de deixar aqui meus sinceros elogios à floricultura pelo trabalho impecável. O atendimento foi simplesmente excelente, com uma equipe atenciosa, prestativa e realmente preocupada em entender e atender às necessidades do cliente.\nAlém disso, é impossível não destacar o carinho e a dedicação presentes em cada detalhe do preparo. Cada arranjo transmite cuidado, sensibilidade e um toque especial que faz toda a diferença. Dá para perceber que tudo é feito com amor e muito capricho.\nParabéns a toda a equipe pelo profissionalismo e pelo cuidado em proporcionar uma experiência tão positiva. Com certeza, conquistaram mais um cliente fiel!' },

    { autor: 'Caio Peres', nota: 5, fonte: 'Google', contexto: 'maio de 2026',
      texto: 'Ótimo atendimento e prestação de serviços, deve toda atenção comigo desde o primeiro contato até a entrega do presente. Super indico em Brasília' },

    { autor: 'Jonny Lima', nota: 5, fonte: 'Google', contexto: '2018',
      texto: 'Flores novinhas, embalagem muito bem feita e um bom atendimento realizado pela Esther' },

    { autor: 'Lorrany Dantas', nota: 5, fonte: 'Google', contexto: '2021',
      texto: 'Atendimento de excelência!\nDona Esther muito preocupada com a qualidade do atendimento ao cliente sempre!' },

    { autor: 'Paulo Mauricio da Silva Ceylao', nota: 5, fonte: 'Google', contexto: '2019',
      texto: 'Excelentes flores com um ótimo preço.' },

    { autor: 'Joquebede Moura', nota: 5, fonte: 'Google', contexto: 'janeiro de 2026',
      texto: 'Excelente atendimento!' }
  ];

  var AVALIACOES_FONTE = 'Avaliações publicadas no Google, transcritas na íntegra.';
  /* `todasCinco` é afirmação verificável, não enfeite: das 11 fichas, nenhuma
     tem nota abaixo de 5 — em 8 anos de Google. Se um dia entrar uma 4, este
     campo vira false e a linha some sozinha. */
  var AVALIACOES_GOOGLE = {
    ligado: true, nota: '5,0', de: 11, todasCinco: true,
    /* A ficha real, pelo CID colhido na pesquisa. É ELE que sustenta o selo:
       um selo de avaliação que não abre a fonte é enfeite, e enfeite não
       prova nada. Some o link e o selo perde o direito de existir. */
    url: 'https://www.google.com/maps?cid=3292062322138215205'
  };

  /* A PDP cita a mesma nota no bloco de provas (17/08/2026). Vai pelo objeto
     exportado, e não copiada para lá: quando a loja passar de 11 avaliações,
     `de` muda numa linha só e as duas páginas acompanham. Se `ligado` virar
     false ou `de` virar 0, a linha da PDP some sozinha, como o selo da home. */
  window.EDELWEISS.GOOGLE = AVALIACOES_GOOGLE;

  /* O artigo é uma seleção de SEIS floriculturas da ASA SUL, de 2020, e a
     Edelweiss é a sexta — não é ranking do DF. Daí a redação contida: é o que
     dá para provar clicando no link. */
  /* Lista, não objeto único: hoje só há uma matéria, mas quando aparecer a
     segunda é acrescentar um item aqui e nada mais. */
  var AVALIACOES_IMPRENSA = [
    {
      texto: 'Uma das seis floriculturas da Asa Sul escolhidas pelo Portal iG',
      veiculo: 'Portal iG · Dia Online, 2020',
      url: 'https://diaonline.ig.com.br/2020/06/19/floriculturas-na-asa-sul-melhores-opcoes-para-surpreender-no-presente/'
    }
  ];

  /* MARCAS DE TERCEIRO — o "G" de quatro cores e a estrela de cinco pontas.
     São desenhos do Google, reproduzidos para ATRIBUIR avaliações que são
     mesmo do Google. Não redesenhe "no estilo da marca": um selo repintado de
     Azul Serra vira material de divulgação da própria loja, que é justamente o
     que não convence. A flor de 8 pétalas continua sendo da Edelweiss e não
     entra aqui. */
  function logoGoogle() {
    return '<svg class="selo-g__logo" viewBox="0 0 48 48" width="20" height="20" aria-hidden="true">'
      + '<path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>'
      + '<path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>'
      + '<path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>'
      + '<path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>'
      + '</svg>';
  }

  function estrela() {
    return '<svg class="selo-g__estrela" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">'
      + '<path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>'
      + '</svg>';
  }

  /* SELO DO GOOGLE — abre a seção.
     Antes a nota era um "5,0" na serifada da marca com a flor de 8 pétalas
     embaixo. Ficava bonito e não passava credibilidade: lia como um número que
     a própria loja escolheu escrever grande. Prova social feita com a tipografia
     de quem se elogia não é prova, é cartaz.

     Este selo é a citação de um artefato de terceiro, então usa a identidade do
     terceiro — o "G" de quatro cores, a estrela de cinco pontas em âmbar, a
     sans em vez da serifada, e superfície BRANCA como o widget de verdade. É
     uma exceção consciente à regra "filete, nunca caixa" desta seção: para o
     selo parecer o que é, ele precisa parecer de fora. Fica como a ÚNICA caixa
     da seção, senão a regra se dissolve.

     E o selo inteiro é um LINK para a ficha do Google. É o que separa citação
     de invenção: qualquer pessoa confere em um clique.

     ACESSIBILIDADE: âmbar #FBBC04 sobre branco dá 1,7:1, longe dos 3:1 de
     elemento gráfico — as estrelas NÃO podem ser as portadoras da informação.
     Quem carrega a nota é o numeral "5,0", que é texto de verdade em 11,9:1; as
     estrelas são decorativas e ficam aria-hidden. */
  function montarNotaGeral() {
    var alvo = $('[data-nota-geral]');
    if (!alvo || !AVALIACOES_GOOGLE.ligado || !AVALIACOES_GOOGLE.de) return;

    var estrelas = '';
    for (var i = 0; i < 5; i++) estrelas += estrela();

    var contexto = AVALIACOES_GOOGLE.de + ' avaliações'
      + (AVALIACOES_GOOGLE.todasCinco ? ' · todas de cinco estrelas' : '');

    var selo = document.createElement(AVALIACOES_GOOGLE.url ? 'a' : 'div');
    selo.className = 'selo-g';
    if (AVALIACOES_GOOGLE.url) {
      selo.href = AVALIACOES_GOOGLE.url;
      selo.target = '_blank';
      selo.rel = 'noopener';
      selo.setAttribute('aria-label', 'Nota ' + AVALIACOES_GOOGLE.nota
        + ' de 5 no Google, de ' + AVALIACOES_GOOGLE.de
        + ' avaliações. Abre a ficha da loja no Google Maps.');
    }

    selo.innerHTML =
        '<span class="selo-g__marca">' + logoGoogle()
      + '<span class="selo-g__nome">Google</span></span>'
      + '<span class="selo-g__corpo">'
      +   '<span class="selo-g__topo">'
      +     '<span class="selo-g__nota">' + AVALIACOES_GOOGLE.nota + '</span>'
      +     '<span class="selo-g__estrelas">' + estrelas + '</span>'
      +   '</span>'
      +   '<span class="selo-g__linha"></span>'
      + '</span>'
      + '<span class="selo-g__ir" aria-hidden="true">'
      +   '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8">'
      +   '<path d="M7 17 17 7M9 7h8v8"/></svg></span>';

    /* textContent no que veio de dado, para número e frase nunca virarem marcação */
    selo.querySelector('.selo-g__linha').textContent = contexto;

    alvo.appendChild(selo);
    alvo.hidden = false;
  }


  function montarAvaliacoes() {
    var secao = $('[data-avaliacoes-secao]');
    var grade = $('[data-avaliacoes]');
    if (!secao || !grade) return;
    if (!AVALIACOES.length) return;   // sem depoimento real, sem seção

    montarNotaGeral();

    grade.innerHTML = '';
    AVALIACOES.forEach(function (av) {
      var card = document.createElement('figure');
      card.className = 'avaliacao' + (av.destaque ? ' avaliacao--destaque' : '');

      /* A fileira de cinco flores saiu de dentro do card. Todas as avaliações
         são 5 estrelas, então ela se repetia idêntica em cada um: informação
         zero e ruído visual. A nota agora é dita uma vez, grande, no topo da
         seção. O leitor de tela continua sabendo — vai no aria-label do card. */
      if (av.nota) card.setAttribute('aria-label', av.nota + ' de 5 estrelas');

      /* textContent, nunca innerHTML: um `&` ou `<` no depoimento não pode
         virar marcação. */
      var fala = document.createElement('blockquote');
      fala.className = 'avaliacao__texto';
      fala.textContent = av.texto;
      card.appendChild(fala);

      var assina = document.createElement('figcaption');
      assina.className = 'avaliacao__autor';
      assina.textContent = av.autor;
      if (av.contexto) {
        var ctx = document.createElement('span');
        ctx.className = 'avaliacao__contexto';
        ctx.textContent = av.contexto;
        assina.appendChild(ctx);
      }
      /* "VIA GOOGLE" repetido embaixo de cada depoimento era metadado com peso
         de conteúdo, e o cabeçalho da seção já diz que a fonte é o Google. Só
         aparece quando a fonte for OUTRA — aí a informação volta a valer. */
      if (av.fonte && av.fonte !== 'Google') {
        var fnt = document.createElement('span');
        fnt.className = 'avaliacao__fonte-item';
        fnt.textContent = 'via ' + av.fonte;
        assina.appendChild(fnt);
      }
      card.appendChild(assina);

      grade.appendChild(card);
    });

    var selo = $('[data-avaliacoes-imprensa]');
    if (selo && AVALIACOES_IMPRENSA.length) {
      AVALIACOES_IMPRENSA.forEach(function (m) {
        var linha = document.createElement('span');
        linha.className = 'avaliacoes__imprensa-item';
        var a = document.createElement('a');
        a.href = m.url;
        a.target = '_blank';
        a.rel = 'noopener';
        a.className = 'avaliacoes__imprensa-link';
        a.textContent = m.texto;
        var v = document.createElement('span');
        v.className = 'avaliacoes__imprensa-veiculo';
        v.textContent = m.veiculo;
        linha.appendChild(a);
        linha.appendChild(v);
        selo.appendChild(linha);
      });
      selo.hidden = false;
    }

    var rodape = $('[data-avaliacoes-fonte]');
    if (rodape) {
      /* A nota saiu daqui: agora ela abre a seção, e repeti-la no rodapé seria
         dizer duas vezes a mesma coisa. No lugar entra o recorte — quantas das
         que têm texto estão no ar. Omitir isso deixaria parecer que a loja só
         tem três avaliações escritas. */
      var linha = AVALIACOES_FONTE;
      var comTexto = AVALIACOES.length + AVALIACOES_ARQUIVO.length;
      if (comTexto > AVALIACOES.length) {
        linha += ' Mostrando ' + AVALIACOES.length + ' das ' + comTexto + ' com texto.';
      }
      if (linha) { rodape.textContent = linha; rodape.hidden = false; }
    }

    secao.hidden = false;
  }

  /* =======================================================================
     ESPAÇO DO VÍDEO DA LOJA

     COMO LIGAR O VÍDEO (não precisa mexer no HTML):
       1. Coloque o arquivo em  site/img/loja.mp4
       2. Troque a linha abaixo para:  var VIDEO_LOJA = 'img/loja.mp4';
     Pronto — o botão de play passa a tocar o vídeo no lugar da foto.

     Enquanto estiver vazio, o quadro mostra a foto da fachada e o play
     avisa que o vídeo ainda não existe, em vez de quebrar.
     ======================================================================= */
  var VIDEO_LOJA = '';   // ex.: 'img/loja.mp4'

  function ligarVideo() {
    var quadro = $('[data-video]');
    var botao  = $('[data-video-play]');
    if (!quadro || !botao) return;

    if (!VIDEO_LOJA) {
      botao.setAttribute('title', 'O video da loja ainda nao foi gravado');
      botao.addEventListener('click', function () {
        var aviso = quadro.querySelector('.video__marca');
        if (!aviso) return;
        aviso.textContent = 'O vídeo ainda não foi gravado';
        setTimeout(function () { aviso.textContent = 'Vídeo em breve'; }, 2600);
      });
      return;
    }

    botao.addEventListener('click', function () {
      var v = document.createElement('video');
      v.src = VIDEO_LOJA;
      v.controls = true;
      v.autoplay = true;
      v.playsInline = true;
      v.setAttribute('poster', quadro.getAttribute('data-poster') || '');
      var img = quadro.querySelector('img');
      if (img) img.remove();
      botao.remove();
      quadro.setAttribute('data-tocando', '');
      quadro.appendChild(v);
    });
  }

  /* =======================================================================
     CABEÇALHO transparente -> sólido
     ======================================================================= */
  function estadoHeader() {
    var h = $('.header');
    if (!h) return;
    var hero = $('.hero');
    if (!hero) { h.setAttribute('data-state', 'solid'); return; }
    h.setAttribute('data-state', window.scrollY > (hero.offsetHeight - 120) ? 'solid' : 'transparent');
  }

  /* =======================================================================
     REVELAÇÃO AO ROLAR
     ======================================================================= */
  function revelar() {
    var alvos = $$('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      alvos.forEach(function (a) { a.classList.add('visivel'); });
      return;
    }

    /* Revela na hora tudo que já está em tela OU acima dela.
       Sem isto, quem abre a página direto numa âncora (#sobre, vindo do menu)
       perde para sempre o que ficou acima do ponto de chegada: o
       IntersectionObserver não dispara para elemento que nunca mais
       intersecta. Foi assim que o título da seção "A loja" sumia. */
    function revelarJaVistos() {
      alvos.forEach(function (a) {
        if (a.classList.contains('visivel')) return;
        if (a.getBoundingClientRect().top < window.innerHeight) {
          a.classList.add('visivel');
        }
      });
    }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visivel'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    alvos.forEach(function (a) { io.observe(a); });

    revelarJaVistos();
    window.addEventListener('load', revelarJaVistos);
    window.addEventListener('hashchange', function () { setTimeout(revelarJaVistos, 60); });
    setTimeout(revelarJaVistos, 350);
  }

  /* =======================================================================
     LIGAÇÕES
     ======================================================================= */
  function ligar() {
    $$('[data-carrinho-abrir]').forEach(function (b) { b.addEventListener('click', abrirCarrinho); });
    $$('[data-carrinho-fechar]').forEach(function (b) { b.addEventListener('click', fecharCarrinho); });
    var oc = $('[data-overlay-carrinho]'); if (oc) oc.addEventListener('click', fecharCarrinho);

    $$('[data-menu-abrir]').forEach(function (b) { b.addEventListener('click', abrirMenu); });
    $$('[data-menu-fechar]').forEach(function (b) { b.addEventListener('click', fecharMenu); });
    var om = $('[data-overlay-menu]'); if (om) om.addEventListener('click', fecharMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { fecharCarrinho(); fecharMenu(); }
    });

    /* `data-msg` entrou em 14/08/2026 com a página de eventos. O número da
       banca é um só e mora aqui — nenhuma página o escreve na mão —, mas o
       assunto de quem chega de `/pages/eventos` não é o mesmo de quem chega da
       home, e uma conversa de orçamento que começa com "Ola" faz a loja
       perguntar de novo o que a página já sabia. Sem o atributo, o
       comportamento é o de sempre: só o link do número. */
    $$('[data-whatsapp]').forEach(function (a) {
      var msg = a.getAttribute('data-msg');
      a.setAttribute('href', 'https://wa.me/' + WHATSAPP +
        (msg ? '?text=' + encodeURIComponent(msg) : ''));
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });

    /* O BOTAO QUE FECHA A GAVETA VIROU LINK (31/08/2026).
       Ate aqui `[data-finalizar]` era um <button> e este trecho montava o
       resumo do pedido e abria o WhatsApp direto da gaveta. Com a pagina de
       checkout, a gaveta deixou de ser o fim do caminho: ela leva para o
       checkout, e e la que o pedido vira mensagem — porque e la que existem
       destinatario, endereco, data e bilhete, que sao justamente os dados
       que faltavam na mensagem antiga.

       O elemento e um <a href> nos 10 arquivos que tem a gaveta, entao NAO
       ha listener nenhum a registrar aqui: o destino muda entre o prototipo
       (`/cart`) e a loja (`/pages/checkout`) e mora no HTML, como ja
       acontecia com o "Continuar comprando" do estado vazio.

       A montagem da mensagem de WhatsApp esta em `checkout.js`. */

    /* duplica a faixa de mimos para o loop nao saltar. As copias levam a
       classe --clone porque no desktop a faixa fica estatica e o CSS as
       esconde; assim o mesmo HTML serve aos dois casos, inclusive ao
       redimensionar a janela. */
    var trilho = $('[data-mimos]');
    if (trilho) {
      Array.prototype.slice.call(trilho.children).forEach(function (item) {
        var copia = item.cloneNode(true);
        copia.classList.add('mimos__item--clone');
        copia.setAttribute('aria-hidden', 'true');
        trilho.appendChild(copia);
      });
    }

    /* ESTEIRA DE CLIENTES. O CSS anda de -50% a 0, então METADE do trilho
       precisa cobrir a viewport — com seis logos (~870px) um único par não
       atravessa um monitor largo e abre buraco. Daí repetir o conjunto até
       cobrir a tela, sempre em número par. */
    var trilhoCli = $('[data-clientes]');
    var quietude = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (trilhoCli && !(quietude && quietude.matches)) {
      var originais = Array.prototype.slice.call(trilhoCli.children);

      var montaEsteira = function () {
        /* Remede a cada chamada: --vao e --logo-h mudam por media query. */
        var vivos = Array.prototype.slice.call(trilhoCli.children);
        var clones = vivos.filter(function (n) {
          return n.classList.contains('clientes__item--clone');
        });
        clones.forEach(function (n) { trilhoCli.removeChild(n); });

        var largura = trilhoCli.scrollWidth;
        if (!largura) {                       // imagens ainda sem layout
          clones.forEach(function (n) { trilhoCli.appendChild(n); });
          return;
        }

        var total = Math.max(2, Math.ceil(window.innerWidth / largura) + 1) * 2;

        var lote = document.createDocumentFragment();
        for (var i = 1; i < total; i++) {
          originais.forEach(function (item) {
            var copia = item.cloneNode(true);
            copia.classList.add('clientes__item--clone');
            copia.setAttribute('aria-hidden', 'true');
            var img = copia.querySelector('img');
            if (img) img.setAttribute('alt', '');
            lote.appendChild(copia);
          });
        }
        trilhoCli.appendChild(lote);
      };

      montaEsteira();
      // no load também: no DOMContentLoaded os PNG ainda podem não ter medida
      window.addEventListener('load', montaEsteira);

      var esperaCli;
      window.addEventListener('resize', function () {
        clearTimeout(esperaCli);
        esperaCli = setTimeout(montaEsteira, 200);
      });
    }

    window.addEventListener('scroll', estadoHeader, { passive: true });
    estadoHeader();

    /* O navegador pula para a âncora (#sobre) DEPOIS do DOMContentLoaded e
       nem sempre dispara 'scroll'. Sem isto, quem abre a página direto numa
       âncora vê o cabeçalho transparente sobre a foto, com o menu ilegível.
       Reavaliamos no load e no hashchange. */
    window.addEventListener('load', estadoHeader);
    window.addEventListener('hashchange', estadoHeader);
    requestAnimationFrame(estadoHeader);
    setTimeout(estadoHeader, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    ligar();
    pintarHome();
    pintarSacola();
    ligarVideo();
    montarAvaliacoes();   // antes de revelar(): a seção nasce `hidden`
    revelar();
    icones();
  });
})();
